import { useCallback, useState } from 'react';
import dayjs from 'dayjs';

const useSetDatesPopover = ({ formValues, applyPreset }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(dayjs());

  const handleOpenSetDates = useCallback(
    (event) => {
      const candidate = formValues.selectionDate || formValues.effectiveDate || formValues.billingDate || null;
      const parsed = candidate ? dayjs(candidate, 'MM/DD/YY') : null;
      setValue(parsed && parsed.isValid() ? parsed : dayjs());
      setAnchorEl(event.currentTarget);
    },
    [formValues.billingDate, formValues.effectiveDate, formValues.selectionDate]
  );

  const handleCloseSetDates = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const applySetDates = useCallback(
    (dayValue) => {
      if (!dayValue || !dayValue.isValid || !dayValue.isValid()) return;
      setValue(dayValue);
      applyPreset('setDates', { dateValue: dayValue });
      handleCloseSetDates();
    },
    [applyPreset, handleCloseSetDates]
  );

  return {
    anchorEl,
    value,
    isOpen: Boolean(anchorEl),
    handleOpenSetDates,
    handleCloseSetDates,
    applySetDates,
  };
};

export default useSetDatesPopover;
